import type { ScheduleComponent } from '@syncfusion/ej2-react-schedule'

/**
 * refreshEvents(false) calls into processData(), which requires activeView.startDate().
 * After React mount or before the Day view is ready, activeView can be missing — guard to avoid runtime errors.
 */
export function safeRefreshScheduleEvents(schedule: ScheduleComponent | null): void {
  if (!schedule) return

  const root = schedule as unknown as {
    isDestroyed?: boolean
    activeView?: { startDate?: () => Date }
  }

  if (
    root.isDestroyed ||
    !root.activeView ||
    typeof root.activeView.startDate !== 'function'
  ) {
    return
  }

  try {
    schedule.refreshEvents(false)
  } catch {
    /* view not fully initialized */
  }
}
